import React, { useState, useEffect } from "react";

export const GoToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!isVisible && window.pageYOffset > 100) {
        setIsVisible(true);
      } else if (isVisible && window.pageYOffset <= 100) {
        setIsVisible(false);
      }
    };

    // Add a listener for the window resize event to check the screen height.
    const checkScreenHeight = () => {
      if (window.innerHeight >= window.screen.height) {
        setIsVisible(false);
      } else {
        checkScrollTop(); // Call the scroll check function to handle scrolling behavior.
      }
    };

    window.addEventListener("scroll", checkScrollTop);
    window.addEventListener("resize", checkScreenHeight); // Listen for resize events.

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
      window.removeEventListener("resize", checkScreenHeight); // Remove event listeners on unmount.
    };
  }, [isVisible]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`btn-to-top absolute rounded-top ${
        isVisible ? "visible" : "hidden"
      }`}
      onClick={scrollToTop}
    >
      <span className="btn rounded-circle rounded-circles">
        <i className="bi bi-chevron-up text-white"></i>
      </span>
    </div>
  );
};
